module.exports = __webpack_public_path__ + "img/landing-page-bg.25cd2124.jpg";